import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { GridOptions } from "ag-grid/main";
import {AccessControl,UserRolePagesMapping,Role,EDIT_BTN} from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-access-control-details',
  templateUrl: './access-control-details.component.html',
  styleUrls: ['./access-control-details.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AccessControlDetailsComponent implements OnInit {
  @ViewChild('header') header: ElementRef;
  ServerConstants: any;
  request:AccessControl;
  roles:Role[];
  sharedData: any;
  roleId:any;
  pages:any;
  pageDetails:Array<any> = [];
  roleName:string;
  rowData:any;
  gridApi:any;
  columnDefs: any;
  context: any;
  tabToNextCell:any;
  navigateToNextCell:any;
  gridOptions: GridOptions;


  userActionNotificationsMap: any;
  noData: Boolean = false;
  EDIT_BTN: string = EDIT_BTN;

  error: Boolean = false;

  private _success = new Subject<string>();
  successMessage: string;

  private _danger = new Subject<string>();
  errorMessage: string;
  errorRadioPermissions:Boolean = false;
  errorRadioAccess:Boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    //private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('accessRoleId') == undefined){
      this.router.navigate(['/admin/accesscontrol']);
    }
  }

  ngOnInit() {

    this.sharedData = this.dataService.getSharedDataObject();

    /* set global values for page */
    this.roleId = this.sharedData.get('accessRoleId');
    //AccessControl request = new AccessControl();
    this.request = new AccessControl(null,null,parseInt(this.roleId));

    //this.request.roleId = parseInt(this.roleId);
    this.getColumnDefinitions();

    this.load();


    /* Success message*/
    this._success.subscribe((message) => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);
    /* error message */
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this.errorMessage = null);


  }

  radioPermissions(event) {
    this.errorRadioPermissions = false;
  }

  radioAccess(event) {
    this.errorRadioAccess = false;
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Page',
        field: 'pageTitle',
      },
      {
        headerName: 'Page Viewable',
        field: 'id',
        cellRenderer: this.getRadioButtons,
      },
      {
        headerName: 'Permissions',
        field: 'id',
        cellRenderer: this.getRadioPermissions,
      }
    ];
    this.context = {
      component: this
    }
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if(nextCell.column.colDef.headerName === "Page Viewable" || nextCell.column.colDef.headerName === "Permissions"){
        return;
      }
      else{
        return nextCell;
      }
    }
    this.navigateToNextCell = function navigateToNextCell(params) {
      var previousCell = params.previousCellDef;
      var suggestedNextCell = params.nextCellDef;
      switch (params.key) {
        case 40:
          return;
        case 38:
          return;
        case 37:
        case 39:
          return;
        default:
          throw "this will never happen, navigation is always on of the 4 keys above";
      }
    };
  }

  getRadioButtons(params) {
    const that = params.context.component;

    // Yes-Radio Btn
    const inputYes = document.createElement('input');
    inputYes.setAttribute('type', 'radio');
    inputYes.setAttribute('class', 'custom-control-input');
    inputYes.setAttribute('id', `${params.data.id}_Yes`);
    inputYes.setAttribute('name', `${params.data.id}_access`);
    inputYes.setAttribute('value', 'Y');

    const labelYes = document.createElement('label');
    labelYes.setAttribute('class', 'custom-control-label');
    labelYes.setAttribute('for', `${params.data.id}_Yes`);
    labelYes.innerHTML = 'Yes';

    const divYes = document.createElement('div');
    divYes.setAttribute('class', 'custom-control custom-radio custom-control-inline');
    inputYes.setAttribute("tabindex", "0");


    // No-Radio Btn
    const inputNo = document.createElement('input');
    inputNo.setAttribute('type', 'radio');
    inputNo.setAttribute('class', 'custom-control-input');
    inputNo.setAttribute('id', `${params.data.id}_No`);
    inputNo.setAttribute('name', `${params.data.id}_access`);
    inputNo.setAttribute('value', 'N');
    inputNo.setAttribute("tabindex", "0");

    const labelNo = document.createElement('label');
    labelNo.setAttribute('class', 'custom-control-label');
    labelNo.setAttribute('for', `${params.data.id}_No`);
    labelNo.innerHTML = 'No';

    const divNo = document.createElement('div');
    divNo.setAttribute('class', 'custom-control custom-radio custom-control-inline');

    for (let i = 0; i < that.pages.length; i++) {
      if (that.pages[i].page.id === params.data.id) {
        let test= that.pages.find(x=> x.page.pageId === params.data.parentPageId);
        /*if (params.data.parentPageId === '' && that.pages[i].navSw === 'Y') {
          params.data['navSw'] = 'Y';
          inputYes.setAttribute('checked', 'true');
        } 
        else if(params.data.parentPageId === '' && that.pages[i].navSw === 'N'){
          params.data['navSw'] = 'N';
          inputNo.setAttribute('checked', 'true');
        }*/
        if(params.data.parentPageId !== '' && test.navSw === 'Y'){
          params.data['navSw'] = 'Y';
          inputYes.setAttribute('checked', 'true');
        }
        else{
          params.data['navSw'] = 'N';
          inputNo.setAttribute('checked', 'true');
        }
      }
    }

    divYes.appendChild(inputYes);
    divYes.appendChild(labelYes);
    divNo.appendChild(inputNo);
    divNo.appendChild(labelNo);

    const div = document.createElement('div');
    div.appendChild(divYes);
    div.appendChild(divNo);

    inputYes.addEventListener('change', () => {
      that.errorRadioAccess = false;
      for (let i = 0; i < that.pages.length; i++) {
        if ((that.pages[i].page.pageId === params.data.parentPageId)){
          that.pages[i].navSw = 'Y';
          for(let j=0; j<that.pages.length; j++){
            if(that.pages[i].page.pageId === that.pages[j].page.parentPageId){
              document.getElementById(that.pages[j].page.id + '_write').removeAttribute('disabled');
              document.getElementById(that.pages[j].page.id + '_Read').removeAttribute('disabled');
              (<HTMLInputElement>document.getElementById(that.pages[j].page.id + '_Yes')).checked = true;
              (<HTMLInputElement>document.getElementById(that.pages[j].page.id + '_No')).checked = false;
            }
          }
        }
      }});
    inputYes.addEventListener('keydown', (event) => {
      if((event.keyCode >=37) && (event.keyCode <=40) ){
        event.preventDefault();
        inputNo.focus();
        inputNo.click();
      }
    });

    inputNo.addEventListener('change', () => {
      that.errorRadioAccess = false;
      for (let i = 0; i < that.pages.length; i++) {
        if ((that.pages[i].page.pageId === params.data.parentPageId)){
          that.pages[i].navSw = 'N';
          for(let j=0; j<that.pages.length; j++){
            if(that.pages[i].page.pageId === that.pages[j].page.parentPageId){
              document.getElementById(that.pages[j].page.id + '_write').setAttribute('disabled', 'true');
              document.getElementById(that.pages[j].page.id + '_Read').setAttribute('disabled', 'true');
              (<HTMLInputElement>document.getElementById(that.pages[j].page.id + '_Yes')).checked = false;
              (<HTMLInputElement>document.getElementById(that.pages[j].page.id + '_No')).checked = true;
            }
          }
        }
      }
    });
    inputNo.addEventListener('keydown', (event) => {
      if((event.keyCode >=37) && (event.keyCode <=40) ){
        that.errorRadioAccess = false;
        event.preventDefault();
        inputYes.focus();
        inputYes.click();
      }
      else if(event.keyCode === 9){
        event.preventDefault();
        let index = params.rowIndex;
        let rowNode = that.gridApi.getDisplayedRowAtIndex(index);
        let firstCol = rowNode.columnApi.getAllDisplayedColumns()[2];
        that.gridApi.ensureColumnVisible(firstCol);
        that.gridApi.setFocusedCell(index, firstCol);
      }
    });

    return div;
  }

  getRadioPermissions(params) {
    const that = params.context.component;

    // Read Only Radio Btn
    const inputReadonly = document.createElement('input');
    inputReadonly.setAttribute('type', 'radio');
    inputReadonly.setAttribute('class', 'custom-control-input');
    inputReadonly.setAttribute('id', `${params.data.id}_Read`);
    inputReadonly.setAttribute('name', `${params.data.id}_permission`);
    inputReadonly.setAttribute('value', 'Y');
    inputReadonly.setAttribute("tabindex", "0");


    const labelYes = document.createElement('label');
    labelYes.setAttribute('class', 'custom-control-label');
    labelYes.setAttribute('for', `${params.data.id}_Read`);
    labelYes.innerHTML = 'Read-Only';

    const divYes = document.createElement('div');
    divYes.setAttribute('class', 'custom-control custom-radio custom-control-inline');


    // Read-Write Radio Btn
    const inputReadWrite = document.createElement('input');
    inputReadWrite.setAttribute('type', 'radio');
    inputReadWrite.setAttribute('class', 'custom-control-input');
    inputReadWrite.setAttribute('id', `${params.data.id}_write`);
    inputReadWrite.setAttribute('name', `${params.data.id}_permission`);
    inputReadWrite.setAttribute('value', 'N');
    inputReadWrite.setAttribute("tabindex", "0");

    const labelNo = document.createElement('label');
    labelNo.setAttribute('class', 'custom-control-label');
    labelNo.setAttribute('for', `${params.data.id}_write`);
    labelNo.innerHTML = 'Read/Write';

    const divNo = document.createElement('div');
    divNo.setAttribute('class', 'custom-control custom-radio custom-control-inline');

    for (let i = 0; i < that.pages.length; i++) {
      if (that.pages[i].page.id === params.data.id) {
        if (that.pages[i].readOnlySw === 'Y') {
          inputReadonly.setAttribute('checked', 'true');
        } else {
          inputReadWrite.setAttribute('checked', 'true');
        }
        if (that.pages[i].navSw === 'N') {
          inputReadonly.setAttribute('disabled', 'true');
          inputReadWrite.setAttribute('disabled', 'true');
        } else {
          inputReadonly.removeAttribute('disabled');
          inputReadWrite.removeAttribute('disabled');
        }
      }
    }
    divYes.appendChild(inputReadonly);
    divYes.appendChild(labelYes);
    divNo.appendChild(inputReadWrite);
    divNo.appendChild(labelNo);

    const div = document.createElement('div');
    div.appendChild(divYes);
    div.appendChild(divNo);

    inputReadonly.addEventListener('change', () => {
      that.errorRadioPermissions = false;
      for (let i = 0; i < that.pages.length; i++) {
        if (that.pages[i].page.id === params.data.id) {
          that.pages[i].readOnlySw = 'Y';
        }
      }
    });
    inputReadonly.addEventListener('keydown', (event) => {
      if((event.keyCode >=37) && (event.keyCode <=40) ){
        that.errorRadioAccess = false;
        event.preventDefault();
        inputReadWrite.focus();
        inputReadWrite.click();
      }
    });

    inputReadWrite.addEventListener('change', () => {
      that.errorRadioPermissions = false;
      for (let i = 0; i < that.pages.length; i++) {
        if (that.pages[i].page.id === params.data.id) {
          that.pages[i].readOnlySw = 'N';
        }
      }
    });
    inputReadWrite.addEventListener('keydown', (event) => {
      if((event.keyCode >=37) && (event.keyCode <=40) ){
        that.errorRadioAccess = false;
        event.preventDefault();
        inputReadonly.focus();
        inputReadonly.click();
      }
    });

    return div;
  }

  load(){
    this.rowData = [];
    this.http.post<AccessControl>(this.ServerConstants.SERVER_API_URL+'/accesscontrol/getPages',this.request ).subscribe(
      (data) => {
        if(data.hasOwnProperty('errorCode')){
          // this.notificationService.error('Payment Summary', this.userActionNotificationsMap.ERROR);
        }else{
          if (data.userRolePageMappingList.length > 0 ){

            this.pages = data.userRolePageMappingList.sort();
            this.pages.sort(function(a, b){
              var nameA=a.page.pageTitle.toLowerCase(), nameB=b.page.pageTitle.toLowerCase()
              if (nameA < nameB) //sort string ascending
                return -1
              if (nameA > nameB)
                return 1
              return 0 //default return value (no sorting)
            });
            for(let i=0; i<this.pages.length; i++){
              if((this.pages[i].page.parentPageId !== null) && (this.pages[i].page.parentPageId !== "")){
                this.rowData.push(this.pages[i].page);
              }
            }
            // this.pageDetails = this.pages.;
            this.gridOptions.api.setRowData(this.rowData);
            this.roleName =data.userRolePageMappingList[0].role.name;

          }else{
            this.pages = undefined;
            this.pageDetails = undefined;
            this.noData = true;
          }
        }
      },response => {
        this.error = true;
        this.notificationService.error('Access Control Details', this.userActionNotificationsMap.ERROR);
      },() => {
        this.error = false;
      });
  }
  submitPageAccessPreferences(){
    this.request.userRolePageMappingList = this.pages;
    console.log(this.request.userRolePageMappingList);
    this.http.post<AccessControl>(this.ServerConstants.SERVER_API_URL+'/accesscontrol/savePermissions', this.request ).subscribe(
      (data: AccessControl ) => {
        // convert date to the proper format for UI
        console.log(data) ;
        this.notificationService.success('Access Control saved successfully');

      },response => {
        this.notificationService.error('Access Control Details', this.userActionNotificationsMap.ERROR);
      },() => {
        this.router.navigate(['/admin/accesscontrol']);
      });
  }
  loadAccessControlSummary(){
    this.router.navigate(['/admin/accesscontrol']);
  }

  resetAccessControlDetails(){
    this.request = new AccessControl(null,null,parseInt(this.roleId));
    this.load();

  }





  parseRefTableData(myData){
    if(myData !== undefined && myData.englishDropDown){

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }

  convertCode(myMap, code){
    if(myMap !== undefined){
      return myMap.get(code);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
      this.gridOptions.api.sizeColumnsToFit();
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }
  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.rowData.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/access-control-details/access-control-details.component.ts